
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/champions-forum",
      function () {
        return require("private-next-pages/events/champions-forum/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/champions-forum"])
      });
    }
  